import { Box, Button } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogState } from '~/hooks/useDialogState';
import {
  EmployeeProposalsDialog,
  EmployeeProposalsTabs,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog';
import { EmployeeRewardingProposalDialogTabs } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/data';

type PropsType = {
  enabledProposalDialogTabs: EmployeeRewardingProposalDialogTabs[];
};

export const BenefitsTab = (props: PropsType) => {
  const { enabledProposalDialogTabs } = props;
  const { t } = useTranslation();
  const { isOpen, open, close } = useDialogState();

  const [openProposalOnTab, setOpenProposalOnTab] =
    useState<EmployeeProposalsTabs>();

  const handleOpenProposalsDialog = (tab: EmployeeProposalsTabs) => {
    setOpenProposalOnTab(tab);
    open();
  };

  return (
    <Box>
      TBA tab content: BenefitsTab
      <Button
        onClick={() =>
          handleOpenProposalsDialog(EmployeeProposalsTabs.BenefitProposal)
        }
      >
        {t('editBenefitProposal')}
      </Button>
      <Button
        onClick={() =>
          handleOpenProposalsDialog(EmployeeProposalsTabs.AllowanceProposal)
        }
      >
        {t('allowanceProposal')}
      </Button>
      <EmployeeProposalsDialog
        open={isOpen}
        onClose={close}
        openOnTab={openProposalOnTab}
        enabledDialogTabs={enabledProposalDialogTabs}
      />
    </Box>
  );
};
